module.exports = __webpack_public_path__ + "static/media/bytt-no-11.5b9c30e5.mp3";